import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { ModalPopupAlertComponent } from '../modal-popup-alert/modal-popup-alert.component';
import { ExcelUploadService } from '../../_services';
import { GlobalDataService } from '../global-data.service';
import { LoginUser } from '../../_models';
import * as XLSX from 'xlsx';

@Component({
  standalone: false,
  selector: 'app-excel-upload',
  templateUrl: './excel-upload.component.html',
  styleUrls: ['./excel-upload.component.css']
})
export class ExcelUploadComponent implements OnInit {
  lstAccruals: any[] = [];
  ErrorResponse: any;
  RemainingContractData: any;
  RemainingContractDataCount!: number;
  output: any;
  user!: LoginUser;
  ErrorResponseCount!: number;
  SuccessCount: number = 0;
  FailureCount: number = 0;
  @ViewChild('fileInput', { static: true }) fileInput: any;
  @Output() onUpload: EventEmitter<any> = new EventEmitter<any>();
  message = true;
  constructor(
    private modalService: NgbModal, private http: HttpClient, private excelservice: ExcelUploadService,
    private gd: GlobalDataService) { }

  ngOnInit() {
    this.user = this.gd.getUserData();
  }

  openAlertModal(strmsg: string) {
    const modalRef = this.modalService.open(ModalPopupAlertComponent);
    modalRef.componentInstance.strText = strmsg;
    modalRef.result.then((result) => {
    }, (reason) => {
    });
  }

  uploadFiles() {
    if (this.fileInput.nativeElement.files[0] == null) {
      this.openAlertModal("Please choose the file to upload");
    } else {
      const file = this.fileInput.nativeElement.files[0];
      const reader = new FileReader();

      reader.onload = (event: any) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const records = XLSX.utils.sheet_to_json(sheet);

        this.output = [];
        this.ErrorResponse = [];
        this.RemainingContractData = [];
        const batchSize = 20;
        let index = 0;
        let globalRowCounter = 0;

        const processNextBatch = () => {
          const batch = records.slice(index, index + batchSize);

          if (batch.length > 0) {
            const formdataBatch = new FormData();
            const batchFile = this.generateExcelFile(batch);
            formdataBatch.append("file", batchFile, `batch_${index / batchSize + 1}.xlsx`);

            this.excelservice.UploadExcel(formdataBatch).subscribe(result => {
              const batchOffset = globalRowCounter;
              let adjustedErrors = [];
              let adjustedRemainingData = [];

              if (Array.isArray(result)) {
                adjustedErrors = result
                  .filter((error: any) => !error.Key.includes("Message"))
                  .map((error: any) => ({
                    Key: batchOffset + parseInt(error.Key, 10),
                    Value: error.Value
                  }));
                this.ErrorResponse = this.ErrorResponse.concat(adjustedErrors);
                this.ErrorResponseCount = this.ErrorResponse.length;

                // Handle remaining contract data (adjustedRemainingData) where Key includes "Message"
                adjustedRemainingData = result
                  .filter((data: any) => data.Key.includes("Message"))
                  .map((contract: any) => {
                    const originalRowNumber = parseInt(contract.Key.replace("Message", ""), 10);
                    const adjustedRowNumber = batchOffset + originalRowNumber;
                    return {
                      Key: "Message" + adjustedRowNumber,
                      Value: contract.Value.replace(`Row${originalRowNumber}`, `Row${adjustedRowNumber}`)
                    };
                  });

                // If there are remaining contract data entries, update RemainingContractData
                if (adjustedRemainingData.length > 0) {
                  this.RemainingContractData = this.RemainingContractData.concat(adjustedRemainingData);
                  this.RemainingContractDataCount = this.RemainingContractData.length;
                  if (this.ErrorResponseCount > 0) {
                    this.message = true;
                  }
                  else {
                    this.message = false;
                  }
                }
              } else if (result === 0 || result === "[]") {
                console.log("No errors in this batch, but rows accounted for.");
              } else {
                console.error("Unexpected result format:", result);
              }
              this.output = this.output.concat(result);
              globalRowCounter += batch.length;
              index += batchSize;
              processNextBatch();
            });
          } else {
            console.log("All records processed successfully.");
            this.onUpload.emit();

            if (this.ErrorResponseCount > 0) {
              this.message = true;
            }
            if (this.output == 0) {
              this.message = false;
            }
            this.SuccessCount = records.length - this.ErrorResponseCount;
            this.FailureCount = this.ErrorResponseCount;

          }
        };

        processNextBatch();
      };

      reader.readAsArrayBuffer(file);
    }
  }

  generateExcelFile(records: any[]): Blob {
    const worksheet = XLSX.utils.json_to_sheet(records);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "BatchData");
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    return new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  }
}
